module.exports = __webpack_public_path__ + "media/images/flags/ao-ad6f3c8c3519f36b36c4cf46ebca2ab5.svg";